import { Routes, Route } from "react-router-dom";
import CustomersListPage from "./list";
import AddCustomerPage from "./add";
import EditCustomerPage from "./edit";
import ViewCustomerPage from "./view";

function CustomersPage() {
	return (
		<Routes>
			<Route path="/" element={<CustomersListPage />} />
			<Route path="add" element={<AddCustomerPage />} />
			<Route path="/:id/edit" element={<EditCustomerPage />} />
			<Route path="/:id" element={<ViewCustomerPage />} />
		</Routes>
	);
}

export default CustomersPage;
